import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
import { useDispatch, useSelector } from 'react-redux'
// components
import { Link } from 'components/UI'
import { AddIcon, RiskTemplateLabel, SectionHeader } from 'components/PageComponents/Risks/Register/views'
// graphql
import { RISK_TEMPLATE_CREATE_MUTATION } from 'graphql/risk/mutations'
// types
import { IRiskTemplateCreateResponse } from 'types/graphql'
// views
import { Wrapper, ArchiveIcon } from './views'
// store
import { addRiskTemplate, riskTemplatesSelector } from 'store/reducers/riskTemplates'
// utils
import { handleError } from 'utils/errors/handlers'

type RiskTemplateCreateResponse = { riskTemplateCreate: IRiskTemplateCreateResponse }

const RiskTemplatesList: React.FC = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [createTemplate] = useMutation<RiskTemplateCreateResponse>(RISK_TEMPLATE_CREATE_MUTATION)

  const riskTemplates = useSelector(riskTemplatesSelector)

  const riskTemplateCreate = async () => {
    try {
      const response = await createTemplate({
        variables: { input: { name: 'Form Template' } }
      })

      const { id } = response.data.riskTemplateCreate.data

      dispatch(addRiskTemplate({ id, name: 'Form Template', archived: false, fields: [] }))

      await router.push(`/forms/templates/edit/${id}`)
    } catch (e) {
      handleError(e, 'RiskRegisterAPI.riskTemplateCreate')
    }
  }

  return (
    <Wrapper>
      <SectionHeader>
        <h2>Templates</h2>
        <AddIcon data-testid='add-risk-template' onClick={riskTemplateCreate} />
      </SectionHeader>

      {riskTemplates.map((riskTemplate) => (
        <RiskTemplateLabel data-testid='risk-template-list-item' key={riskTemplate.id}>
          <Link href={`/forms/templates/edit/${riskTemplate.id}`}>{riskTemplate.name}</Link>
          {riskTemplate.archived && <ArchiveIcon />}
        </RiskTemplateLabel>
      ))}
    </Wrapper>
  )
}

export default RiskTemplatesList
